import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: null
  }),
  getters: {
    isAuthenticated: (state) => !!state.user,
    userInitials: (state) => {
      if (!state.user?.name) return '?'
      return state.user.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    }
  },
  actions: {
    setUser(user) {
      this.user = user
      this.token = user.token
    },
    setToken(token) {
      this.token = token
      if (this.user) this.user.token = token
    },
    logout() {
      this.user = null
      this.token = null
    }
  },
  persist: {
    storage: sessionStorage,
    paths: ['user', 'token']
  }
})
